import React from 'react';
import { IconProps } from '.';

const SvgNumNineFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M11.896 6.887c-2.13-.006-3.568 1.374-3.568 3.268.013 1.758 1.263 3.034 2.956 3.034 1.048 0 1.979-.495 2.422-1.328h.078c-.007 1.882-.684 3.034-1.966 3.034-.755 0-1.296-.41-1.459-1.107H8.432c.19 1.595 1.491 2.787 3.386 2.787 2.37 0 3.886-1.888 3.88-5.091 0-3.425-1.849-4.59-3.802-4.597Zm-1.654 3.216c-.013-.937.703-1.673 1.667-1.68a1.677 1.677 0 0 1 1.68 1.667c0 .905-.736 1.667-1.693 1.667-.97 0-1.654-.723-1.654-1.654Z'
      />
    </svg>
  );
};

export default SvgNumNineFill;
